module.exports = __webpack_public_path__ + "img/ar.d47f68a5.svg";